<template>
	<div class="form-group" :class="[{'has-feedback':!!icon},setStates,setGsize]">
		<label v-if="!!label" :class="[setLcol]" class="control-label">{{label}}</label>
		<template v-if="!!col">
			<div :class="[setCol]">
				<slot></slot>
				<span v-if="!!icon" class="iconfont form-control-feedback" :class="hasIcon"></span>
				<span v-if="!!help" class="help-block">{{help}}</span>
			</div>
		</template>
		<template v-else>
			<slot></slot>
			<span v-if="!!icon" class="iconfont form-control-feedback" :class="hasIcon"></span>
			<span v-if="!!help" class="help-block">{{help}}</span>
		</template>
	</div>
</template>

<script>
	import bsfInput from './input'
	export default {
		name: 'bsf-form-group',
		components: {
			bsfInput
		},
		props: {
			gsize: {
				type: String,
			},
			icon: {
				type: String,
			},
			help: {
				type: String,
			},
			label: {
				type: String,
			},
			col: {
				type: [Number, String],
			},
			states: {
				type: String,
			},
			csize:{
				type: String
			}
		},
		data: function() {
			return {}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		computed: {
			setGsize() {
				return this.gsize ? ('form-group-' + this.gsize) : '';
			},
			setCol() {
				return this.col ? ('col-' + this.csize + '-' + this.col) : '';
			},
			setLcol() {
				return this.col ? ('col-' + this.csize + '-' + (12 - this.col)) : '';
			},
			hasIcon() {
				return this.icon ? ('icon-' + this.icon) : '';
			},
			setStates() {
				return this.states ? ('has-' + this.states) : '';
			}
		}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	@import (reference) "../../../assets/lib/css.less";
	.form-control {
		input& {
			.unbdr;
		}
	}
</style>


// WEBPACK FOOTER //
// formgroup.vue?5c9ecd6e